import jsPDF from 'jspdf';

export const generatePDFLabels = async (containers, wine) => {
    if (!containers.length) {
        alert('No containers available for this wine.');
        return;
    }

    const logoPath = '/img/j-logo.png';
    const logoWidth = .7;
    const logoHeight = 1.3;
    const textStartX = logoWidth + 0.75;
    const lineX = logoWidth + 0.35;

    const pdf = new jsPDF({ orientation: 'landscape', unit: 'in', format: [4, 6] });

    for (let i = 0; i < containers.length; i++) {
        const container = containers[i];
        if (i > 0) {
            pdf.addPage();
        }

        // Add the logo
        try {
            const logo = await fetch(logoPath).then((res) => res.blob()).then((blob) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            });
            pdf.addImage(logo, 'PNG', 0.25, .5, logoWidth, logoHeight);
        } catch (error) {
            console.error('Error loading logo image:', error);
            // Consider adding user notification here
        }

        // Add vertical line
        pdf.setDrawColor(0, 0, 0);
        pdf.setLineWidth(0.01);
        pdf.line(lineX, .5, lineX, 3);

        // Add horizontal line
        pdf.setDrawColor(0, 0, 0);
        pdf.setLineWidth(0.01);
        pdf.line(.25, 2, 1, 2);

        // Add text with consistent font sizes
        pdf.setFont("Helvetica", "bold");
        
        // Rotated vintage
        pdf.setFontSize(50);
        pdf.text(`${wine.vintage || ''}`, .75, 3.5, null, 90);
        
        // Main text
        pdf.setFontSize(28);
        pdf.text(textStartX, .5,`ID: ${wine.wineID || ''}`)
        pdf.setFontSize(32);
        pdf.text(textStartX, 1.2, 'JEREMY WINE CO.');
        pdf.text(textStartX, 1.75, `${wine.varietal || ''}`);
        
        // Smaller text
        pdf.setFontSize(20);
        pdf.text(textStartX, 2.2, `${wine.appellation || ''} - ${wine.vineyard || ''}`);
        pdf.text(textStartX, 2.5, `${wine.varietalDetail || ''}`);

        pdf.setFontSize(28);
        pdf.text(textStartX, 3.5,`BARREL ID: ${container.containerID || ''}`)

        
    }

    pdf.save(`Wine_${wine.wineID}_Labels.pdf`);
};